import './App.css';
import jsyaml from "js-yaml";
import {useEffect, useState} from 'react';

const defaultSeason = 22;

const preparePoints = (points) => {
    const SKIP_DAYS = 15;
    points = points.sort((a, b) => b - a);
    const candidates = points.slice(SKIP_DAYS).filter((el) => el < 0);
    return points.slice(0, SKIP_DAYS).concat(candidates);
}

const seasonNames = [
    "Нулевой", "Первый", "Второй", "Третий", "Четвёртый", "Пятый", "Шестой", "Седьмой", "Восьмой", "Девятый",
    "Десятый", "Одиннадцатый", "Двенадцатый", "Тринадцатый", "Четырнадцатый", "Пятнадцатый",
    "Шестнадцатый", "Семнадцатый", "Восемнадцатый", "Девятнадцатый", "Двадцатый", "Двадцать первый",
    "Двадцать второй", "Двадцать третий", "Двадцать четвёртый", "Двадцать пятый", "Двадцать шестой"
]

const comparePlayers = (a, b) => {
    if (a[1]['rating'] === b[1]['rating']) {
        return a[1]['visits'] - b[1]['visits'];
    }
    return b[1]['rating'] - a[1]['rating'];
}

const PlayerLine = (props) => {
    return <li className='b-games-li-player'>
        {props.name}
        {props.points !== 0 && <p className='b-games-li-points'>{props.points}</p>}
    </li>;
}

const TotalLine = (props) => {
    return <tr className={`b-rating-player b-rating-player__${props.place}`}>
        <td className='b-rating-row'>{props.name === props.winner ? '👑' : props.place}</td>
        <td className='b-rating-name'>{props.name}</td>
        <td className='b-rating-points'>{props.sum}</td>
        <td className='b-rating-visits'>{props.visits}</td>
        <td className='b-rating-rating'>{props.rating}</td>
    </tr>;
}

const TotalTable = (props) => {
    const [showResults, setShowResults] = useState(false);
    const onClick = () => setShowResults(!showResults);
    return <div>
        <table className='b-rating-table'>
            <thead>
            <tr>
                <th/>
                <th>Игрок</th>
                <th title='Получил голосов за лучшего игрока'>Голоса</th>
                <th title='Сколько игр посетил игрок'>Посещения</th>
                <th title='Голоса + Посещения'>Рейтинг</th>
            </tr>
            </thead>
            <tbody>
            {[...props.total.entries()]
                .map(([player, val], index) =>
                    (showResults || index < 12) &&
                    <TotalLine key={index} place={index + 1} name={player} winner={props.winner} {...val}/>)}
            </tbody>
        </table>
        <div className='b-show-all'>
            <a className='b-show-all-link' onClick={onClick} href='#'>
                {showResults ? 'Двенадцать лучших' : 'Показать всех'}</a>
        </div>
    </div>;
}

const GameReport = (props) => {
    return (
        <ul className='b-games-li'>
            <h2>{props.label}</h2>
            <p className='b-games-li-date'>{props.date}</p>
            {Object.entries(props['result'])
                .sort((x, y) => y[1] - x[1])
                .map(([name, points]) =>
                    <PlayerLine key={name} name={name} points={points}/>)}
        </ul>);
}

function WinnerTable(props) {
    return <div className="b-final">
        <h1>Финальный стол</h1>
        <table>
            <thead>
            <tr>
                <th>Игрок</th>
                <th>Баллы</th>
            </tr>
            </thead>
            <tbody>
            {Object.entries(props.data)
                .sort((x, y) => y[1] - x[1])
                .map(([name, points], idx) =>
                    <tr key={idx} className={idx === 0 ? "b-final-gold" : undefined}>
                        <td>{name}</td>
                        <td className="b-final-points">{points}</td>
                    </tr>)}
            </tbody>
        </table>
    </div>;
}

const App = () => {
    const [data, setData] = useState(false);
    const [season, setSeason] = useState(window.season || defaultSeason);
    useEffect(() => {
        if (!data) {
            fetch(`/data/${season}.yaml?timestamp=${new Date().getTime()}`)
                .then(res => res.blob())
                .then(blob => blob.text()).then((yamlAsString) => {
                const allData = jsyaml.load(yamlAsString);
                allData['total'] = new Map();
                allData['games'].forEach((game) => {
                    Object.entries(game['result']).forEach(([name, points]) => {
                        if (!(allData['total'].has(name))) {
                            allData['total'].set(name, {'points': []});
                        }
                        allData['total'].get(name)['points'].push(points);
                    });
                });
                allData['total'].forEach((val, key) => {
                    val['sum'] = preparePoints(val['points']).reduce((a, b) => a + b, 0);
                    val['visits'] = preparePoints(val['points']).length;
                    val['rating'] = val['visits'] + val['sum'];
                });
                allData['total'] = new Map([...allData['total']].sort(comparePlayers));
                setData(allData);
            });
        }
    }, [data]);
    return (
        <div>
            {data ?
                <div>
                    {data['final'] && <WinnerTable data={data['final']}/>}
                    <div className='b-rating'>
                        <h1>Рейтинг игроков. {seasonNames[season]} сезон</h1>
                        <a href='rules.html'>Правила игры в «Мафию»</a>
                        <br/>
                        {season > 1 && <a href={`?season=${season - 1}`}>
                            {seasonNames[season - 1]} сезон (архив)</a>}
                        <TotalTable winner={data['winner']} total={data['total']}/>
                    </div>
                    <div style={{clear: 'both'}}>
                        {data['games'].map((game) => <GameReport key={game['date']} {...game}/>)}
                    </div>
                </div>
                : <div>Загрузка...</div>
            }
        </div>);
}

export default App;
